import { Link } from 'react-router-dom';
import { faqGroups } from '@/mocks/faq';
import FaqAccordion from '@/components/feature/FaqAccordion';
import SectionHeading from '@/components/feature/SectionHeading';

export default function HomeFaqSection() {
  const items = [...faqGroups[1].items.slice(0, 3), ...faqGroups[0].items.slice(0, 2)];

  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
        <div className="lg:col-span-4">
          <SectionHeading
            align="left"
            eyebrow="常见问题"
            tone="primary"
            title="参与之前，先解决这几个疑问"
            desc="我们把被问得最多的几个问题整理出来，如果这里没有你要的答案，可以到常见问题页继续找。"
          />
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            查看全部问答
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="lg:col-span-8">
          <FaqAccordion items={items} />
        </div>
      </div>
    </section>
  );
}